import React, { useEffect } from "react";
import { Layers } from "react-feather";
import { Route, Routes, useParams } from "react-router-dom";
import PluginInstanceEditScreen from "../pluginInstance/PluginInstanceEditScreen";
import RunScriptListScreen from "../runScript/RunScriptListScreen";
import UsageAdminScreen from "../usage/UsageAdminScreen";
import FeatureFlagsScreen from "../flags/FeatureFlagsScreen";
import OrgSettingsScreen from "../settings/OrgSettingsScreen";
import Tabs from "../global/PageTabs";
import SelectOrganization from "./SelectOrganization";
import OrganizationList from "./OrganizationList";
import { Banner } from "@cinesys/ui/components";
import { useOrganizationAuthCheck } from "../../hooks/useOrganizationAuthCheck";

const tabs = [
  { key: "plugin", label: "Plugins" },
  { key: "script", label: "Scripts" },
  { key: "usage", label: "Usage" },
  { key: "flags", label: "Feature Flags" },
  { key: "settings", label: "Settings" },
];

interface Props {
  setSystemDomainId: (systemDomainId: string | undefined) => void;
}

const HomeRouter = (props: Props) => {
  const { setSystemDomainId } = props;
  const { systemDomainId } = useParams();
  const { data: authStatus } = useOrganizationAuthCheck();
  const orgAuth = systemDomainId ? authStatus?.[systemDomainId] : undefined;

  useEffect(() => {
    setSystemDomainId(systemDomainId);
  }, [systemDomainId, setSystemDomainId]);

  return (
    <div>
      {systemDomainId ? (
        <>
          <Tabs mode="wrap" tabs={tabs} icon={Layers} link>
            <SelectOrganization />
          </Tabs>
          {orgAuth && !orgAuth.valid && (
            <Banner
              padTop
              error={`Authentication failed for this organization: ${
                orgAuth.error ?? "unknown error"
              }`}
            />
          )}
          <Routes>
            <Route path="plugin/*" element={<PluginInstanceEditScreen />} />
            <Route
              path="script/:scriptId?/*"
              element={<RunScriptListScreen />}
            />
            <Route path="usage/*" element={<UsageAdminScreen />} />
            <Route path="flags/*" element={<FeatureFlagsScreen />} />
            <Route path="settings/*" element={<OrgSettingsScreen />} />
          </Routes>
        </>
      ) : (
        <OrganizationList />
      )}
    </div>
  );
};

export default HomeRouter;
